import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "react-oidc-context";

const DescriptionModal = ({ isOpen, onClose, hotel, onSuccess }) => {
  const [description, setDescription] = useState(hotel?.description || "");
  const [loading, setLoading] = useState(false);

  const auth = useAuth();
  const token = auth.user?.access_token;
  const API_URL = process.env.REACT_APP_API_URL || "/api";

  useEffect(() => {
    if (isOpen && hotel) {
      setDescription(hotel.description || "");
    }
  }, [isOpen, hotel]);

  const handleSave = async () => {
    if (!hotel?.id) return;

    setLoading(true);
    try {
      await axios.patch(
        `${API_URL}/hotels/${hotel.id}/description`,
        { description },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Informer le parent du succès
      onSuccess && onSuccess();

      // Fermer la modal
      onClose();
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la description:", error);
      alert("Erreur lors de la sauvegarde de la description");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setDescription(hotel?.description || "");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-lg w-full mx-4">
        <div className="flex items-center justify-between p-6 border-b">
          <h3 className="text-lg font-semibold text-gray-900">Description de l'hôtel</h3>
          <button onClick={handleClose} disabled={loading} className="text-gray-400 hover:text-gray-600 disabled:opacity-50">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="p-6">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Hôtel: <span className="font-semibold">{hotel?.name}</span>
            </label>
            <textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Entrez une description pour cet hôtel..." rows={6} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 resize-none" disabled={loading} />
          </div>

          <div className="flex justify-end space-x-3">
            <button type="button" onClick={handleClose} disabled={loading} className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 focus:ring-2 focus:ring-gray-500 disabled:opacity-50">
              Annuler
            </button>
            <button type="button" onClick={handleSave} disabled={loading} className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 disabled:opacity-50">
              {loading ? "Sauvegarde..." : "Sauvegarder"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DescriptionModal;
